<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="dashboardsCreateDialogTitle"
    class="text-s2 mb-9 mt-5 flex-grow text-left text-2xl font-semibold"
    >New Dashboard</div
  >

  <div class="text-s400 text-base">{{ newDashboardPath }}</div>

  <div class="mt-9 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Title</div
      >
    </div>

    <div [formGroup]="titleForm" class="ml-5 flex flex-col items-start">
      <input
        #dashboardTitle
        autocomplete="off"
        spellcheck="false"
        data-cy="dashboardsCreateDialogTitleInput"
        class="form-input border-s3 focus:border-m600 h-9 w-96 rounded"
        [ngClass]="{
          'border-r600':
            titleForm.controls['title'].invalid &&
            titleForm.controls['title'].touched
        }"
        formControlName="title"
      />
      <m-validation [control]="titleForm.controls['title']"></m-validation>
    </div>
  </div>

  <div class="mt-2 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Space</div
      >
    </div>

    <div
      class="ml-5 flex flex-col items-start"
      [tp]="templateSpecifyDashboardSpace"
      [tpIsEnabled]="canSpecifyDashboardSpace === false"
    >
      <ng-template #templateSpecifyDashboardSpace>
        <div>Only Admins and Editors can change space</div>
      </ng-template>

      <ng-select
        #dashboardsCreateDialogSpaceSelect
        [fixNgSelectBottom]="dashboardsCreateDialogSpaceSelect"
        data-cy="dashboardsCreateDialogSpaceSelect"
        class="select-h-10 w-96 flex-shrink-0"
        [class.report-space-select-disabled]="
          canSpecifyDashboardSpace === false
        "
        [items]="spacesPlusEmpty"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [disabled]="canSpecifyDashboardSpace === false"
        [(ngModel)]="selectedSpace"
        (change)="spaceChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          dashboardsCreateDialogSpaceSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          dashboardsCreateDialogSpaceSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="space"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{
            item.space === emptySpaceName ? '' : item.label
          }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="mt-8 flex min-h-[100px] flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Access Roles</div
      >
    </div>

    <div class="ml-5 flex flex-col items-start">
      <div [tp]="templateAccessRoles" [tpIsEnabled]="roles.length === 0">
        <ng-template #templateAccessRoles>
          <div>Project has no roles</div>
        </ng-template>

        <ng-select
          #dashboardsCreateDialogRoleSelect
          [fixNgSelectBottom]="dashboardsCreateDialogRoleSelect"
          data-cy="dashboardsCreateDialogRoleSelect"
          class="min-h-11 w-96 flex-shrink-0"
          [items]="roles"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [(ngModel)]="selectedAccessRoles"
          (change)="accessRolesChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation();
            dashboardsCreateDialogRoleSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation();
            dashboardsCreateDialogRoleSelect.blur()
          "
          appendTo="body"
          bindLabel="roleId"
          bindValue="roleId"
        >
          <ng-template ng-label-tmp ng-option-tmp let-item="item">
            <div class="ml-1 truncate text-base">{{ item.roleId }}</div>
          </ng-template>
        </ng-select>

        <div class="text-s400 ml-[14px] mt-2 w-96 text-base">
          {{ combinedAccessRolesText }}
        </div>
      </div>
    </div>
  </div>

  <div class="mt-9">
    <button
      data-cy="createBranchDialogCreateButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="create()"
      >Create</button
    >

    <button
      data-cy="createBranchDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>

<div *ngIf="alias$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="struct$ | async"></div>
